
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/general-conditions-of-sale",
      function () {
        return require("private-next-pages/general-conditions-of-sale.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/general-conditions-of-sale"])
      });
    }
  